export class InvoiceAdjustmentModel {
    Id: number;
    InvoiceId: number;
    Description: string;
    Amount: number;
    Gst: number;
    DateCreated: Date;

    constructor() {
        this.Description = "";
    }
}